import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

import { saveAndRefetchCustomer } from "api/customers";
import { customersKeys } from "api/customers/queries";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import AddSocialNumberForm, {
  AddSocialNumberFormValues,
} from "./AddSocialNumberForm";

interface AddSocialNumberModalProps {
  isOpen: boolean;
  handleClose: () => void;
  customerId: string;
}

const AddSocialNumberModal: FC<AddSocialNumberModalProps> = ({
  isOpen,
  handleClose,
  customerId,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const queryCache = useQueryClient();

  const { mutateAsync: addSocialNumber, status } = useMutation(
    async (data: any) => {
      const res = await saveAndRefetchCustomer(customerId, data);
      await queryCache.invalidateQueries(customersKeys.details(customerId));
      return res.data;
    },
  );
  const handleSubmit = async (values: AddSocialNumberFormValues) => {
    const mappedValues: any = {
      ...values,
    };

    await addSocialNumber(mappedValues, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="Add Social Number"
        subtitle="Add a social security number for this customer."
      />
      <AddSocialNumberForm
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        submitStatus={status}
      />
    </AppDialog>
  );
};

export default AddSocialNumberModal;
